module.exports = __webpack_public_path__ + "static/img/a2.e93548b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/a2.png
// module id = /HvJ
// module chunks = 1